import { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2 } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza',
    product: 'Compró el MEGAPACK',
    text: 'Antes llegaba re cansada al lunes. Ahora abro el tomo y en 5 minutos tengo la clase armada.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata',
    product: 'Compró el MEGAPACK',
    text: 'Lo compré medio desconfiado, la verdad. Me sorprendió: está mucho más completo de lo que esperaba.',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe',
    product: 'Compró el MEGAPACK',
    text: 'Los warm-ups y los cierres me salvaron. Se nota que la clase tiene orden de principio a fin.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén',
    product: 'Compró el MEGAPACK',
    text: 'Me ahorró un montón de tiempo. Ya no pierdo los domingos armando sesiones. Muy recomendable.',
    bg: 'bg-brandBlue-electric'
  }];
  return <Section className="bg-bg-alt" data-id="element-165" data-mp="3gbtyuuu0z33o">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-166" data-mp="3gasbbqvtoo52">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-3 md:mb-4 text-[32px]" data-id="element-167" data-mp="3ubbf2lt9981f">
          Lo que dicen <span className="text-brandOrange" data-id="element-168" data-mp="3pd9ziav1fqup">los profes</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-169" data-mp="1zx23qa5hvhqo">
          <div className="flex text-gold" data-id="element-170" data-mp="1uyqzcexyxzfu">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-171" data-mp="3v0qikcs1bqs1" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-172" data-mp="3tw1j5gxqbpb">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-173" data-mp="7v9a3nbewszx">
            · +150 entrenadores del país
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-174" data-mp="csr6yfc5nhrk">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-175" data-mp="msrvqgssmq35" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-176" data-mp="mr716r6hb75a">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-177" data-mp="rlus0woygdn1">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-178" data-mp="vkaaqoe06zun">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-179" data-mp="15heygsnhz3dk">
                  <div className="flex text-gold mb-0.5" data-id="element-180" data-mp="1fnzg9yfbf9f0">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-181" data-mp="1ao3jok8y6k9h" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-182" data-mp="15q1t7e96zinz">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-183" data-mp="1ydxw50pcu6t7">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-184" data-mp="1tfmmapz27waz">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange mt-auto" data-id="element-185" data-mp="1knccvavznuus">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-186" data-mp="1wv63obuyxf3x">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-187" data-mp="1wu4ez4l14u3q">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-188" data-mp="21vblz1fclp9c">
          <div className="absolute inset-0 bg-gradient-to-b from-[rgba(212,164,28,0.05)] to-transparent pointer-events-none" data-id="element-189" data-mp="1nw2fitgy29ik"></div>
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-190" data-mp="1ryp2oh2o769f" />
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-191" data-mp="2kl0e6mrterl0">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-192" data-mp="2auynrobzox2x">
            <p data-id="element-193" data-mp="2yiyfaqh4krik">Abrís los tomos. Los usás en tus clases.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-194" data-mp="33ct58bnbq2q3">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-195" data-mp="mxpiqwbo7uwf" />
              devolución del 100%.
            </p>
            <p data-id="element-196" data-mp="mxfrl5ew3hp5">Sin formularios. Sin drama. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-197" data-mp="11lkc8exi63ak">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para cualquier nivel de grupo?',
    a: 'Sí. Cada sesión incluye Versión A para principiantes, Versión B para intermedios y Versión C para avanzados. Podés dictar la misma clase a un grupo mixto sin problema.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo con el link de descarga. En menos de 5 minutos tenés todo en tu celular, tablet o computadora.'
  }, {
    q: '¿Necesito equipamiento especial para usarlo?',
    a: 'No. La mayoría de las sesiones se pueden dictar con equipamiento básico de cualquier gym: mancuernas, kettlebells y bandas. Cada sesión indica los materiales necesarios con íconos.'
  }, {
    q: '¿Funciona si no soy profe de escuela sino instructor de gym?',
    a: 'Este producto fue creado específicamente para instructores y coaches de funcional en gimnasios, boxes y grupos. Es exactamente para vos.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si no es lo que esperabas, mandás un mail y devolvemos el 100% del pago. Sin formularios. Sin drama.'
  }, {
    q: '¿Puedo usar el MEGAPACK con más de un grupo?',
    a: 'Sí. Podés dictar las sesiones en todos tus grupos y horarios, sin límite. Es tuyo para siempre: lo descargás una vez y lo usás todo el año.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-198" data-mp="zwglzqtf0m3s">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-199" data-mp="zvdsdb4pk5k6">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-200" data-mp="3d81j7rry5t96">
          ❓ LO QUE MÁS NOS <span className="text-brandOrange" data-id="element-201" data-mp="3473bayee11lb">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-202" data-mp="3458qdk3499h8">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-203" data-mp="2z7gygq2h1nd1" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-204" data-mp="2pgmdrq4vivtp">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-205" data-mp="2gfo4asbo1w3q">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandOrange shrink-0" size={20} data-id="element-206" data-mp="26k35t45t3dyq" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-207" data-mp="3vbebil1zxqed" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-208" data-mp="3lg4bu3z2lv3r">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3hs buscando sesiones por semana',
    costo: '156hs por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupo que abandona'
  }, {
    sin: 'Sin adaptaciones por nivel',
    costo: 'El nuevo no vuelve'
  }, {
    sin: 'Sin programa anual',
    costo: 'Mismos circuitos'
  }, {
    sin: 'Domingo en Instagram',
    costo: 'Mismo ciclo cada año'
  }];
  return <Section className="bg-bg-base" data-id="element-209" data-mp="2e4zwjddv4vkz">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-210" data-mp="2e61abpm9jw6e">
        <h2 className="font-display font-extrabold uppercase text-[32px] md:text-[44px] leading-[1.1] text-center text-txt-primary mb-8 md:mb-12" data-id="element-211" data-mp="2a34ychr8aybf">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-212" data-mp="2j31hk3uun4z3" />
          <span className="text-brandOrange" data-id="element-213" data-mp="2j2i87bj9lowo">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-214" data-mp="2x2t1el81rfl0">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-215" data-mp="2t1qzfwmqwpfc">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-216" data-mp="2szeinmsq4l3v">
              Sin el MEGAPACK
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-217" data-mp="31t9f86fs537w">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-218" data-mp="3bs8onr8dd2vy">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-219" data-mp="3dxh2qjp7lvf0" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-220" data-mp="3968u3pvpee2w">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-center gap-1.5" data-id="element-221" data-mp="30758ae55jkkp">
                  <span data-id="element-222" data-mp="3rx08x6ygmwoo">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-223" data-mp="3nuvei606tw0z">
          Tu próximo entrenamiento puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-224" data-mp="27gvgx1oteigw">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-225" data-mp="n0p6q5g2shmc">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-226" data-mp="rzs9fj8l2br5">
          <p className="font-display font-extrabold uppercase text-[30px] md:text-[40px] leading-[1.15] text-txt-primary" data-id="element-227" data-mp="rwmh7v4nqtr7">
            Puedes{' '}
            <span className="text-brandOrange" style={{
            textShadow: '0 0 12px rgba(255,107,0,0.22)'
          }} data-id="element-228" data-mp="10ramvme5adgj">
              improvisar
            </span>{' '}
            la siguiente clase,
            <br data-id="element-229" data-mp="1ar1mg2hkbinh" />
            o entrar con todo resuelto.
          </p>
          <p className="font-display font-black uppercase text-[30px] md:text-[40px] leading-[1.15] text-brandOrange animate-pulse" data-id="element-230" data-mp="1fotaumj00mmx">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-231" data-mp="3hgzo2gzkps38">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-232" data-mp="3hi11ut7z4son">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-233" data-mp="no82ims5bbuu"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange mb-3 md:mb-4" data-id="element-234" data-mp="11p11bjphct3r">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 border-brandOrange px-5 py-3 md:px-6 md:py-4 rounded-[14px] shadow-[0_0_30px_rgba(255,107,0,0.4)] animate-glow-button" data-id="element-235" data-mp="1bl3z6ddau5kw">
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-236" data-mp="1lbqd835dao1h">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-237" data-mp="1ubvhi4f9l6bf">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-238" data-mp="1pen1a9dofcct">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-239" data-mp="2dwvnc70lrbva">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandOrange leading-none" data-id="element-240" data-mp="200i68yzzdchc">
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-241" data-mp="1q6j96eerkiw9">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-242" data-mp="1g8bu6141caww">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandOrange text-left shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-243" data-mp="1la18bpmk14p7">
            <h4 className="font-display font-extrabold uppercase text-[20px] md:text-[26px] leading-[1.1] text-txt-primary text-center" data-id="element-244" data-mp="1c8unx5gsb9qo">
              MEGAPACK FUNCIONAL <span className="text-brandOrange" data-id="element-245" data-mp="149q10ta60ewc">365™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-246" data-mp="z9c3442a2lc1">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-247" data-mp="qfz1mdq5ebec">
              {['6 Tomos principales — 365 sesiones', '5 Bonos estratégicos incluidos', 'Versiones A/B/C por nivel', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-248" data-mp="bjq1zb2chw1e">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-249" data-mp="7ie98wo6cuoz" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-250" data-mp="25v4vm2yh8fmf">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-251" data-mp="3jrfyo127sgck">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-252" data-mp="3oq90uxc1wkxf">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-253" data-mp="1dzqdz5hjiu4">
                $99.990 ARS
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandOrange/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-254" data-mp="35uiz9b815qk2">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-255" data-mp="39trteh6zfqg5">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[44px] md:text-[60px] leading-none text-brandOrange mt-1" data-id="element-256" data-mp="p42fq7i0map1">
                $19.990{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-257" data-mp="2q738tfqco6bg">
                  ARS
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-258" data-mp="2m4q6z2eq4sjy">
                Pago único · Incluye garantía de 7 días
              </p>
            </div>

            <div className="mt-4 md:mt-5" data-id="element-259" data-mp="2v77r9batjb4b">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-260" data-mp="2v43is1qblt7u">
                QUIERO EL MEGAPACK COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-261" data-mp="2cdlqfy9egzn0">
          <span className="flex items-center gap-2" data-id="element-262" data-mp="1jraq8opph0qq">
            <Lock size={14} data-id="element-263" data-mp="1jqhq46l959hk" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-264" data-mp="3ve4hq9ldzib9">
            <Clock size={14} data-id="element-265" data-mp="3vc9x6we11s7p" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-266" data-mp="40gwvu0vgji5">
            <ShieldCheck size={14} data-id="element-267" data-mp="3mdodgxwtk75c" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-268" data-mp="3mfizygnqo7bj">
            <CreditCard size={14} data-id="element-269" data-mp="3qft7vyv3d7t1" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-270" data-mp="myt3b80effa1">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-271" data-mp="8ys2tto1q9v3">
        <div data-id="element-272" data-mp="8yif6cqh4esk">
          <h2 className="font-display font-black text-xl text-txt-primary mb-1" data-id="element-273" data-mp="914ke5pw6i7m">
            🏋️ MEGAPACK FUNCIONAL 365™
          </h2>
          <p className="font-sans font-bold text-sm text-brandOrange" data-id="element-274" data-mp="2tohg4293pnlo">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-275" data-mp="2yporsced76xm">
          El sistema de clases listas número 1 para instructores y coaches de
          funcional en Latinoamérica. Porque dar una buena clase no debería
          costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[13px] text-txt-muted pt-4" data-id="element-276" data-mp="3gead1y5ixtyk">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-txt-primary transition-colors" data-id="element-277" data-mp="3bgr0d2oh5p8q">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-278" data-mp="36z63p6sq0as">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-279" data-mp="3uc8pgy0abgbf">
          <p className="font-sans text-xs text-txt-faint" data-id="element-280" data-mp="vn9wdquxrahe">
            © 2024 Center Shop Digital. Todos los derechos reservados.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-281" data-mp="qvrtuyd9l1ub">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-282" data-mp="y87vj898iwnp">
              Términos y condiciones
            </a>
            <span data-id="element-283" data-mp="137kgfngjptnn">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-284" data-mp="138vk7n9zr1er">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};